import { Component, Input } from "@angular/core";
import { DialogService } from "@kno2/data-access/api-desktop";

@Component({
    selector: "kno2-topnav",
    templateUrl: "./topnav.component.html",
    styleUrls: ["./topnav.component.scss"],
    standalone: false
})
export class TopnavComponent {
    @Input() public showReleaseFolderButton = false;

    constructor(private dialogService: DialogService) {}

    public showFolderClick(): void {
        this.dialogService.openReleaseFolder();
    }
}
